// src/pages/private/members/calendarTools/event/auctions/eventAuctionConstants.js

export const EVENT_AUCTION_MANAGE_RESOURCE = "private.navbar.calendar.event.auctions";
export const EVENT_AUCTION_ACCESS_RESOURCE = "private.navbar.calendar.event.auctions.access";
export const EVENT_AUCTION_ROUTE = "/members/calendar/auctions/:occurrenceId";
